import { find } from "lodash";
import { h } from "preact";
import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "../../../node_modules/@sgwt-widget/core";
import { ApiBackedScComponent } from "../../common/components/ApiBackedScComponent";
import { BarChartOpt } from "../../common/components/BarChartOpt";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
} from "../../common/generic/generic-helper";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericRequest } from "../../common/generic/generic-types";
import { ConvertFilter } from "../../common/salescredit/salescredit-filter-help";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "../../common/salescredit/salescredit-search-criteria";
import { IProps } from "../../common/salescredit/salescredit-types";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";
import { ICprSalesCreditSearchCriteria } from "../../common/utils/types";
import { BuildStackBarChartOptions, mapData } from "../utils/helper";

interface IState {
  criteria: ICprSalesCreditSearchCriteria;
  email: string;
  options: any;
}

export class SalesCreditVeByYearClass extends ApiBackedScComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  constructor() {
    super();
    this.setState({
      criteria: {},
      email: "",
      options: undefined,
    });
  }
  public renderWithDataReady(): JSX.Element {
    return <BarChartOpt options={this.state.options} />;
  }
  protected shouldFetchApiData(nextProps: IProps): boolean {
    return true;
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");
    const headers = props.headers;

    const filtersConverted = ConvertFilter(props.filters);
    const filters = BuildSalesCreditFilters(filtersConverted);

    const kpis = [SCKpis.SC_YTD, SCKpis.SC_YTD_1];

    const genericRequest: IGenericRequest = {
      aggregationAttributes: SCAttributes.SC_MARK_IS_ELEC,
      date: CreateDateFromFilter(filtersConverted),
      filter: GenericFilterBuilder(filters),
      kpis: kpis.join(","),
    };

    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setDataStatus("too-many-clients");
      this.setState({
        options: undefined,
      });
    } else {
      const responseData = await MakeGenericApiCall(
        headers,
        "sc",
        genericRequest,
        this.props.widgetConfiguration,
        this.state.correlationId
      );
      const errorStatus = CheckReponseDataForError(responseData);
      if (errorStatus) {
        this.setDataStatus(errorStatus);
        this.setStatusText(responseData.statusText);
        this.setState({
          options: undefined,
        });
        return;
      }
      const mappedData = mapData(responseData);
      const stackBarChartOptions = BuildStackBarChartOptions(mappedData);
      if (responseData !== undefined) {
        this.setState({
          criteria: genericRequest,
          options: stackBarChartOptions,
        });
        this.setDataStatus("ready");
      } else {
        this.setState({
          criteria: {},
          options: undefined,
        });
        this.setDataStatus("no-data");
      }
    }
  }
}

export const SalesCreditVeByYear = withWidgetConfiguration(
  SalesCreditVeByYearClass
);
